module.exports = __webpack_public_path__ + "static/media/astro.f7794068.svg";